import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bank--statement-filter"
// URL construction for the statement-history period filter. The menu chrome
// (popover, tabs, active badges, F hotkey) is bank--transaction-filter-menu — this
// controller is the statements counterpart of bank--transaction-filter, minus
// everything that page filters on that a statement list has no notion of.
//
// The statements index is a full page, not a turbo frame, so applying a filter is a
// visit rather than a frame src swap.
export default class extends Controller {
  static targets = ["dateFrom", "dateTo"]
  static outlets = ["bank--transaction-filter-menu"]

  connect() {
    this.setFilterValues()
    this.boundHandlePopstate = this.setFilterValues.bind(this)
    window.addEventListener("popstate", this.boundHandlePopstate)
  }

  disconnect() {
    window.removeEventListener("popstate", this.boundHandlePopstate)
  }

  setFilterValues() {
    const params = new URLSearchParams(window.location.search)
    if (this.hasDateFromTarget) {
      this.dateFromTarget.value = params.get("date_from") || ""
    }
    if (this.hasDateToTarget) {
      this.dateToTarget.value = params.get("date_to") || ""
    }
  }

  activeStatusChecker() {
    if (!this.hasBankTransactionFilterMenuOutlet) {
      return
    }
    const menu = this.bankTransactionFilterMenuOutlet
    if (!menu.hasActiveStatusDateTarget) {
      return
    }
    const isActive = Boolean(this.#value(this.dateFromTarget) || this.#value(this.dateToTarget))
    menu.toggleActiveStatus(isActive, menu.activeStatusDateTarget)
  }

  applyFilters() {
    this.#visit(this.#constructUrl())
  }

  cancelFilters() {
    this.removeValuesFromFilters()
    this.activeStatusChecker()
    this.#visit(this.#constructUrl())
  }

  removeValuesFromFilters() {
    for (const target of [this.dateFromTarget, this.dateToTarget]) {
      if (target) {
        target.value = ""
      }
    }
  }

  // Chip "x" — clears the whole period, because the backend treats a half-open range
  // as invalid (DateRangeFilterable) and would flash an error instead of filtering.
  cancelChipFilter() {
    this.cancelFilters()
  }

  #constructUrl() {
    const url = new URL(window.location.href)
    url.search = ""
    const from = this.#value(this.dateFromTarget)
    const to = this.#value(this.dateToTarget)
    if (from) {
      url.searchParams.set("date_from", from)
    }
    if (to) {
      url.searchParams.set("date_to", to)
    }
    return url.toString()
  }

  #visit(url) {
    if (window.Turbo) {
      window.Turbo.visit(url)
    } else {
      window.location.assign(url)
    }
  }

  #value(target) {
    return target?.value?.trim() || ""
  }
}
